import HomeApp from "@/_roots/home/HomeApp.vue";
import VueInstance from "@/main";

VueInstance(HomeApp);
